import { useMemo } from "react";
import { useQuery } from "@apollo/client/react";
import { type AutomationWhereInput, connectionRows, GetAutomationsDocument } from "#app/lib/data";

// Lists workspace automations. `where` should be a stable reference (memoized
// or module-level) per the app's Apollo variables rule.
export function useAutomations(where?: AutomationWhereInput) {
  const variables = useMemo(() => ({ where, limit: 100, skip: 0 }), [where]);
  const { data, loading, error, refetch } = useQuery(GetAutomationsDocument, {
    variables,
    fetchPolicy: "cache-and-network",
  });

  const automations = useMemo(() => connectionRows(data?.automations), [data]);

  return {
    automations,
    isLoading: loading,
    initialLoading: loading && !data,
    error,
    refetch,
  };
}

// The list-row shape every automations surface consumes — derived from the
// codegen fragment so the schema stays the single source of truth.
export type AutomationListItem = ReturnType<
  typeof useAutomations
>["automations"][number];
